import React from 'react'
import { InputGroup, FormControl, DropdownButton, Dropdown } from 'react-bootstrap'
import Item from './item'

/*
    Multi selectable dropdown
    Use with complex objects or simple string array

    String array example:
    const items = ['a', 'b', 'c']
    const values = ['a', 'c']
    <DropDownFilter
        items={items}
        title={values.length ? 'Dimensions' : 'All Dimensions'}
        onChange={newValues => {}}
        values={values}
    />

    Complex objects example:
    const items = [{ id: 'a', name: 'A' }, { id: 'b', name: 'B' }]
    const values = ['a', 'c']
    <DropDownFilter
        items={items}
        title={values.length ? 'Dimensions' : 'All Dimensions'}
        onChange={newValues => {}}
        values={values}
        keyProp='id'
        valueProp: 'name'
    />
*/
const CheckedMultiSelector = ({
    title = '',
    items = [],
    values = [],
    onChange = () => {},
    disabled,
    keyProp,
    valueProp,
}) => {
    const onSelected = (selected) => {
        if (values.includes(selected)) {
            onChange(values.filter(v => v !== selected))
        } else {
            onChange([...values, selected])
        }
    }
    title = `${title} ${values.length ? `(${values.length})` : ''}`
    return (
        <InputGroup>
            <FormControl
                value={title}
                onChange={() => {}} 
                disabled={disabled}
            />

            <DropdownButton
                title = ''
                alignRight
                as={InputGroup.Append}
                variant="primary"
                disabled={disabled}
            >
                {items.map((item, k) => (
                    <Item
                        key={k}
                        active={values.includes(keyProp ? item[keyProp] : item)}
                        onClick={() => onSelected(keyProp ? item[keyProp] : item)}
                    >{valueProp ? item[valueProp] : item}</Item>
                ))}
                <Dropdown.Divider />
                <Dropdown.Item onClick={() => onChange([])}>Clear</Dropdown.Item>
            </DropdownButton>
        </InputGroup>
    )
}

export default CheckedMultiSelector